import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onBeforeUnmount, onMounted, ref } from 'vue';
import { usePageToolbar } from '@/core/hooks/usePageToolbar';

/**
 * Teleports secondary page actions (print/PDF, refresh, sync, …)
 * into the header "Thao tác" submenu dropdown.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeaderActions',
  setup(__props) {

const { registerActionsPanel, actionsOpen } = usePageToolbar();
const targetReady = ref(false);
let rafId = 0;

function waitForSlot() {
  if (document.getElementById('page-toolbar-actions-slot')) {
    targetReady.value = true;
    return;
  }
  rafId = requestAnimationFrame(waitForSlot);
}

function onMenuClick(event: MouseEvent) {
  const target = event.target as HTMLElement | null;
  if (target?.closest('button, a, [role="menuitem"]')) {
    actionsOpen.value = false;
  }
}

onMounted(() => {
  registerActionsPanel(true);
  waitForSlot();
});

onBeforeUnmount(() => {
  targetReady.value = false;
  if (rafId) {
    cancelAnimationFrame(rafId);
  }
  registerActionsPanel(false);
});

return (_ctx: any,_cache: any) => {
  return (targetReady.value)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "#page-toolbar-actions-slot"
      }, [
        _createElementVNode("div", {
          class: "page-header-actions",
          role: "none",
          onClick: onMenuClick
        }, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})